<header class="page-header">
    <h1>{{'page.upload.name' | translate | upperFirstLetter }}</h1>
</header>

<app-syncro-information status="pending" title="upload.progression.warning.title"
    message="upload.progression.warning.message"
    icon="information" />

<div class="field download-infos">
    <kin-icon name="chrono_stroke" />
    <p>
        <span class="strong">{{ 'upload.progression.estimated_time' | translate }}</span>
        {{transferTimeEstimation() ? (transferTimeEstimation()! | formatDuration) : '-'}}
        {{transferSpeed() ? (transferSpeed()! | fileSize) + '/s' : '-'}}
    </p>
</div>

@if(workoutUpload){
<app-upload-file-progress-block [progressSource]="workoutUpload" icon="workout_stroke" [title]="'upload.progression.workout'"
    [fileWeight]="undefined" [fileDuration]="uploadService.workoutDuration"
    [fileName]="createContentService.title()" (complete)="workoutUploadComplete.set(true)" />
}

@if(gpsFile() && gpsUploadUrl()){
<app-upload-file-progress-block [file]='gpsFile()!' [uploadUrl]="gpsUploadUrl()!" icon="lock" [title]="'gps_uploader.title'"
    [fileWeight]="mediaBlockService.gpsFileData()?.weight" [fileDuration]="mediaBlockService.gpsFileData()?.duration"
    [fileName]="mediaBlockService.gpsFileData()?.name" (complete)="gpsUploadComplete.set(true)" />
}

@if(videoFile() && videoUploadUrl()){
<app-upload-file-progress-block [file]='videoFile()!' [uploadUrl]="videoUploadUrl()!" icon="video" [title]="'upload.progression.video'"
    [fileWeight]="mediaBlockService.videoFileData()?.weight"
    [fileDuration]="mediaBlockService.videoFileData()?.duration" [fileName]="mediaBlockService.videoFileData()?.name"
    (complete)="videoUploadComplete.set(true)" />
}